export default {
  title: 'Información empresarial',
  form: {},
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Información guardada correctamente.',
  },
};
